import axios from 'axios';

export const changePassword = (oldPassword, newPassword) =>
  axios
    .post('/api/change-password', { oldPassword, newPassword })
    .then(response => response.data)
    .catch(error => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/account/_api.js